import type { DirecaoDaOrdem, OrdemDaEntrada, PastaDaEntrada } from '@/api/chamados'

/**
 * De onde o chamado foi aberto (spec 2026-10-21 detalhe do chamado §4): a pasta da Entrada e os
 * filtros dela. Vai no `state` da navegação; sem ele (link direto, notificação), o detalhe mostra
 * só o ←.
 */
export interface OrigemDaEntrada {
  pasta: PastaDaEntrada
  q?: string | null
  org?: number | null
  fila?: number | null
  /** A ordem da lista (`?ordem=&dir=`): ↑ ↓ andam na mesma sequência que a pessoa via. */
  ordem?: OrdemDaEntrada | null
  dir?: DirecaoDaOrdem | null
}

/** O `state` que a Entrada passa ao abrir um chamado, e que ↑ ↓ repassam. */
export interface EstadoDaLeitura {
  entrada: OrigemDaEntrada
}

/** Lê a origem do `location.state`, que é `unknown`: qualquer outra forma vira `null`. */
export function origemDoEstado(state: unknown): OrigemDaEntrada | null {
  const entrada = (state as { entrada?: unknown } | null)?.entrada as Partial<OrigemDaEntrada> | undefined
  if (!entrada || typeof entrada.pasta !== 'string') return null
  return entrada as OrigemDaEntrada
}

/** Anterior e próximo de `id` na ordem da pasta. Fora da lista, os dois são `null`. */
export function vizinhosNaPasta(ids: number[], id: number): { anterior: number | null; proximo: number | null } {
  const i = ids.indexOf(id)
  if (i < 0) return { anterior: null, proximo: null }
  return {
    anterior: i > 0 ? ids[i - 1] : null,
    proximo: i < ids.length - 1 ? ids[i + 1] : null,
  }
}

/** A Entrada na pasta e nos filtros da origem — o destino do ← quando há origem. */
export function hrefDaEntrada(origem: OrigemDaEntrada): string {
  const p = new URLSearchParams({ pasta: origem.pasta })
  if (origem.org != null) p.set('org', String(origem.org))
  if (origem.fila != null) p.set('fila', String(origem.fila))
  if (origem.ordem != null) {
    p.set('ordem', origem.ordem)
    if (origem.dir != null) p.set('dir', origem.dir)
  }
  return `/chamados/inbox?${p.toString()}`
}
